import { StyledBody } from "./style"

const Body: React.FC = ({ children }) => {
  return <StyledBody>{children}</StyledBody>
}

export default Body
